/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'NUTRITION',
              'EXERCISE',
              'DRUG_AND_ALCOHOL_ABUSE',
              'SMOKING',
              'SEXUAL_HEALTH',
              'PRE__AND_POST_NATAL',
              'MENTAL_WELL_BEING',
              'ACCESS_TO_CLEAN_DRINKING_WATER',
              'OTHER',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    are_all_wrkrs_offered_any_of_the_following_programs_by_the_fac: valueSchema,
  },
}
